module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-banner.29c49825.jpg";